import { Box } from '@mui/material';
import type { SxProps, Theme } from '@mui/material';
import ReactMarkdown from 'react-markdown';

// Renders teacher feedback (and similar text) authored in Markdown — bold,
// numbered/bulleted lists, headings, paragraphs — with MUI-consistent spacing.
// Raw HTML is NOT rendered (react-markdown default), so it is safe.
export function Markdown({ children, sx }: { children: string; sx?: SxProps<Theme> }): JSX.Element {
  return (
    <Box
      sx={[
        {
          fontSize: 14,
          lineHeight: 1.6,
          wordBreak: 'break-word',
          '& > :first-of-type': { mt: 0 },
          '& > :last-child': { mb: 0 },
          '& p': { my: 0.75 },
          '& ul, & ol': { my: 0.75, pl: 3 },
          '& li': { mb: 0.5 },
          '& li > p': { my: 0 },
          '& strong': { fontWeight: 700 },
          '& em': { fontStyle: 'italic' },
          '& h1, & h2, & h3, & h4, & h5, & h6': {
            fontWeight: 700,
            mt: 1.5,
            mb: 0.5,
            fontSize: '1rem',
            lineHeight: 1.3,
          },
          '& a': { color: 'primary.main' },
          '& blockquote': {
            my: 0.75,
            pl: 1.5,
            borderLeft: '3px solid',
            borderColor: 'divider',
            color: 'text.secondary',
          },
          '& code': {
            fontFamily: 'monospace',
            fontSize: '0.85em',
            bgcolor: 'action.hover',
            px: 0.5,
            py: 0.1,
            borderRadius: 0.5,
          },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <ReactMarkdown>{children}</ReactMarkdown>
    </Box>
  );
}
